<template>
    <div class="row">
        <div class="button-group">
            <square-button v-for="(button, index) in buttons" :key="index" @click="handleClick(button.label)"
                :icon="button.icon" :isDisabled="button.disabled || !canEditContract" :isHidden="button.hidden"
                :aspectRationChange="hasPricingTableActive">
                {{ button.label }}
            </square-button>
        </div>
    </div>
    <hr />
    <div class="row">
        <div v-if="variableButtons.length > 0" class="button-group-variable">
            <div v-for="(button, index) in variableButtons" :key="index">
                <variable-field-button :has_replace_button="true" :isDefault="button.is_default" :disabled="!canEditContract"
                    @click="handleVariableClick(button.section_id, button.field_value)"
                    @replace="handleReplace(button.section_id, button.field_value)">
                    {{ button.label }}
                </variable-field-button>
                <hr>
            </div>
        </div>
    </div>

    <div class="row" v-if="this.showTestimonial">
        <testimonial-variable-field></testimonial-variable-field>
    </div>

    <!-- <div class="row" v-if="this.showImageGridSettings">
        <ImageGridVariableField></ImageGridVariableField>
    </div> -->

    <Teleport to="body">
    <PricingTableModal ref="pricingTableModal" :setItems="setItems" :isLoading="isLoading" @update-pricing-table="updatePricingTable" @save-contract="saveContract" @has-changes="handlePricingChanges" @rebuild-schedule="rebuildSchedule"/>
    </Teleport>

    <div class="row" style="margin-left: 0px; max-height: 850px; overflow-y: auto;"
        v-if="false">
        <div class="row">
            <button class="col-4 button-select continue" @click.stop="buildPricingTable()"
                :disabled="!hasPricingTableChanges"><i class="fa-solid fa-wrench"></i> &nbsp; Build Table</button>
            <div class="col-4"></div>
            <button class="col-4 button-select continue" @click.stop="addPricingOption()"><i
                    class="fa-solid fa-table"></i> &nbsp; Add Option</button>
        </div>
        <div class="row">
            <br>
        </div>
        <div class="row">
            <table class="product-table">
                <thead>
                    <tr>
                        <th>Product</th>
                        <th>Description</th>
                        <th>Notes</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Discount</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in productList" :key="index">
                        <td class="product-name-cell" :title="item.product"
                            @click.stop="startEdit(index, 'product')">
                            <strong v-if="!item.isEditingProduct">{{ item.product }}</strong>
                            <input v-else v-focus type="text" v-model="item.product" class="product-name-input"
                                @click.stop
                                @blur="endEdit(item, 'product')"
                                @keyup.enter="endEdit(item, 'product')" />
                        </td>
                        <td @click.stop="startEdit(index, 'description')">
                            <span v-if="!item.isEditingDescription">{{ item.description }}</span>
                            <input v-else type="text" v-model="item.description" @blur="endEdit(item, 'description')"
                                @keyup.enter="endEdit(item, 'description')" />
                        </td>
                        <td @click.stop="startEdit(index, 'remarks')">
                            <span v-if="!item.isEditingRemarks">{{ item.remarks }}</span>
                            <input v-else type="text" v-model="item.remarks" @blur="endEdit(item, 'remarks')"
                                maxlength="254" @keyup.enter="endEdit(item, 'remarks')" />
                            <span class="char-counter">
                                {{ (item.remarks || '').length }}/254
                            </span>
                        </td>
                        <td style="text-align: center;" @click.stop="startEdit(index, 'quantity')">
                            <span v-if="!item.isEditingQuantity">{{ item.quantity }}</span>
                            <input v-else type="number" v-model.number="item.quantity" @blur="endEdit(item, 'quantity')"
                                @keyup.enter="endEdit(item, 'quantity')" />
                        </td>
                        <td @click.stop="startEdit(index, 'pricing')">
                            <span v-if="!item.isEditingPricing">{{ formatCurrency(item.pricing) }}</span>
                            <input v-else type="number" v-model.number="item.pricing" @blur="endEdit(item, 'pricing')"
                                @keyup.enter="endEdit(item, 'pricing')" />
                        </td>
                        <td @click.stop="startEdit(index, 'discount')">
                            <span v-if="!item.isEditingDiscount">{{ formatCurrency(item.discount) }}</span>
                            <input v-else type="number" v-model.number="item.discount" @blur="endEdit(item, 'discount')"
                                @keyup.enter="endEdit(item, 'discount')" />
                        </td>
                        <!-- <td>{{ formatCurrency(item.discount) }}</td> -->
                        <td> <button class="button-select remove-button" @click.stop="removeProduct(index)"><i
                                    class="fa-solid fa-trash-can"></i></button></td>
                    </tr>
                    <tr class="add-product-row">
                        <td @click="addProduct(productList.length)">
                            <span>+ Product</span>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr v-if="isSelectingProduct">
                        <td colspan="7">
                            <div style="max-height: 300px; overflow-y: auto;">
                                <table class="product-selection-table">
                                    <tbody>
                                        <tr v-for="(product, index) in availableProducts" :key="index">
                                            <td style="color: #00bcd4"><strong>{{ product.name }}</strong></td>
                                            <!-- <td>{{ product.description ? product.description : "No Product Description" }}
                                        </td> -->
                                            <td>{{ formatCurrency(product.defaultPricing) }}</td>
                                            <td>
                                                <button class="button-select continue"
                                                    @click.stop="selectProduct(product)">Select</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="pricingOptionCount > 1">
            <div v-for="(productOption, index) in productListOptions" :key="index">
                <span class="orange-label-product-option" style="margin-left: -10px;">Product Pricing for Option {{
                    this.toOptionName(index + 2) }}</span>
                <div class="row">
                    <div class="col-12" style="margin-left: -10px;">
                        <table class="product-table">
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Description</th>
                                    <th>Notes</th>
                                    <th>Quantity</th>
                                    <th>Price</th>
                                    <th>Discount</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in productOption.productList" :key="index">
                                    <td class="product-name-cell" :title="item.product"
                                        @click.stop="startEditOption(productOption.productList, index, 'product')">
                                        <strong v-if="!item.isEditingProduct">{{ item.product }}</strong>
                                        <input v-else v-focus type="text" v-model="item.product" class="product-name-input"
                                            @click.stop
                                            @blur="endEditOption(item, 'product')"
                                            @keyup.enter="endEditOption(item, 'product')" />
                                    </td>
                                    <td style="text-align: center;"
                                        @click.stop="startEditOption(productOption.productList, index, 'description')">
                                        <span v-if="!item.isEditingDescription">{{ item.description }}</span>
                                        <input v-else type="text" v-model="item.description"
                                            @blur="endEditOption(item, 'description')"
                                            @keyup.enter="endEditOption(item, 'description')" />
                                    </td>
                                    <td @click.stop="startEditOption(productOption.productList, index, 'remarks')">
                                        <span v-if="!item.isEditingRemarks">{{ item.remarks }}</span>
                                        <input v-else type="text" v-model="item.remarks"
                                            @blur="endEditOption(item, 'remarks')"
                                            @keyup.enter="endEdit(item, 'remarks')" maxlength="254" />
                                        <span class="char-counter">
                                            {{ (item.remarks || '').length }}/254
                                        </span>
                                    </td>
                                    <td style="text-align: center;"
                                        @click.stop="startEditOption(productOption.productList, index, 'quantity')">
                                        <span v-if="!item.isEditingQuantity">{{ item.quantity }}</span>
                                        <input v-else type="number" v-model.number="item.quantity"
                                            @blur="endEditOption(item, 'quantity')"
                                            @keyup.enter="endEditOption(item, 'quantity')" />
                                    </td>
                                    <td @click.stop="startEditOption(productOption.productList, index, 'pricing')">
                                        <span v-if="!item.isEditingPricing">{{ formatCurrency(item.pricing) }}</span>
                                        <input v-else type="number" v-model.number="item.pricing"
                                            @blur="endEditOption(item, 'pricing')"
                                            @keyup.enter="endEdit(item, 'pricing')" />
                                    </td>
                                    <td @click.stop="startEditOption(productOption.productList, index, 'discount')">
                                        <span v-if="!item.isEditingDiscount">{{ formatCurrency(item.discount) }}</span>
                                        <input v-else type="number" v-model.number="item.discount"
                                            @blur="endEditOption(item, 'discount')"
                                            @keyup.enter="endEdit(item, 'discount')" />
                                    </td>
                                    <!-- <td>{{ formatCurrency(item.discount) }}</td> -->
                                    <td> <button class="button-select remove-button"
                                            @click.stop="removeProductOption(productOption, productOption.productList, index)"><i
                                                class="fa-solid fa-trash-can"></i></button></td>
                                </tr>
                                <tr class="add-product-row">
                                    <td @click="addProductOption(productOption, productOption.productList.length)">
                                        <span>+ Product</span>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2" style="text-align: end;" @click="removeOption(productOption)">
                                        <span>Remove Option</span>
                                    </td>
                                </tr>
                                <tr v-if="productOption.isSelectingProduct">
                                    <td colspan="7">
                                        <div style="max-height: 300px; overflow-y: auto;">
                                            <table class="product-selection-table">
                                                <tbody>
                                                    <tr v-for="(product, index) in availableProducts" :key="index">
                                                        <td style="color: #00bcd4"><strong>{{ product.name }}</strong>
                                                        </td>
                                                        <!-- <td>{{ product.description ? product.description : "No Product Description" }}
                                        </td> -->
                                                        <td>{{ formatCurrency(product.defaultPricing) }}</td>
                                                        <td>
                                                            <button class="button-select continue"
                                                                @click.stop="selectProductOption(productOption, product)">Select</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue-tel-input/dist/vue-tel-input.css'
import 'vue-multiselect/dist/vue-multiselect.css'
import "@/assets/scss/vue-multiselect.scss";
import SquareButton from '@/components/Utilities/square-button.vue';
import VariableFieldButton from '@/components/Utilities/variable-field-button.vue';
import TestimonialVariableField from '@/components/ContentLibrary/TestimonialVariableFields.vue';
import PricingTableModal from './PricingTableModal.vue';
//import ImageGridVariableField from '@/components/ContentLibrary/ImageGridVariableFields.vue';
import { log } from '@/plugins/helper.js'
import { isEmpty } from '../../plugins/helper';


//const _ = require('lodash');

export default {

    components: {
        SquareButton,
        VariableFieldButton,
        TestimonialVariableField,
        PricingTableModal,
        //ImageGridVariableField
    },

    directives: {
        focus: {
            mounted(el) {
                el.focus();
            }
        }
    },

    emits: ['onSubmit', 'onDelete', 'onReady', 'pricingTableActive', 'pricingTableInActive', 'update-pricing-table', 'save-contract', 'pricing-table-changes', 'rebuild-schedule'],

    props: {
        item: {
            type: Object,
            // required: true,
        },

        isHidden: {
            type: Boolean,
        },

        setItems: {
            type: Object,
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            organisationVariableFields: [],
            organisations: [],
            rolesVariableFields: [],
            productVariableFields: [],
            userVariableFields: [],
            buttons: [
                //{ label: 'Block Details', icon: 'fa-solid fa-circle-info', disabled: false, hidden: false },
                { label: 'Master Terms', icon: 'fa-solid fa-gavel', disabled: false, hidden: false },
                { label: 'Standard', icon: 'fa-solid fa-cube', disabled: false, hidden: false },
                { label: 'Term', icon: 'fa-solid fa-clock', disabled: false, hidden: false },
                { label: 'Subscription', icon: 'fa-solid fa-rotate', disabled: false, hidden: false },
                { label: 'Schedule', icon: 'fa-solid fa-calendar-days', disabled: false, hidden: false },
                { label: 'Execution Page', icon: 'fa-solid fa-clipboard-check', disabled: false, hidden: false },
                // ---- hidden/not applicable to contracts ----
                { label: 'Cover Page', icon: 'fa-solid fa-file-lines', disabled: false, hidden: true },
                { label: 'Product / Service', icon: 'fa-solid fa-box-open', disabled: false, hidden: true },
                { label: 'Pricing Table', icon: 'fa-solid fa-hand-holding-dollar', disabled: false, hidden: false },
                { label: 'Image Grid', icon: 'fa-solid fa-images', disabled: false, hidden: true },
                { label: 'Testimonials', icon: 'fa-solid fa-comments', disabled: false, hidden: true },
                { label: 'Video', icon: 'fa-solid fa-photo-film', disabled: true, hidden: true },
                { label: 'Content', icon: 'fa-solid fa-feather', disabled: false, hidden: true },
                { label: 'Conflict of Interest', icon: 'fa-solid fa-triangle-exclamation', disabled: false, hidden: true },
                { label: 'Insurance', icon: 'fa-solid fa-kit-medical', disabled: false, hidden: true },
                { label: 'WHS Responsibilities', icon: 'fa-solid fa-briefcase', disabled: false, hidden: true },
                { label: 'Terms & Condition', icon: 'fa-solid fa-file-signature', disabled: false, hidden: true },
                { label: 'Acceptance / Execution', icon: 'fa-solid fa-clipboard-check', disabled: false, hidden: true },
                { label: 'Organisation Table', icon: 'fa-solid fa-sitemap', disabled: false, hidden: true },
            ],
            variableButtons: [

            ],
            showTestimonial: false,
            showImageGridSettings: false,
            showPricingTableSettings: false,
            allBlocks: [],
            isSelectingProduct: false,
            pricingOptionCount: 1,
            //product pricing table
            availableProducts: [
                // Sample Data for structure:
                // { name: 'PenTesting Basic', description: 'Basic website penetration testing service', defaultQuantity: 1, defaultDiscount: 0.00, defaultPricing: 100.00 },
            ],
            tempAvailableProducts: [

            ],
            productListOptions: [
            ],
            products: [],
            productList: [
                //Sample Data for structure:
                // { product: 'PenTester', description: 'Pentests websites', quantity: 12, discount: 10.00, pricing: 50.00 },
            ],
            filteredContractItems: [],
            newProductIndex: -1, // To track which row is being edited for adding a product
            isCharityLead: false,
            hasPricingTableChanges: false,
            hasPricingTableActive: false,
            //isLoading: false,
        }
    },

    computed: {
        // calculateTotalPrice() {
        //     return this.productList.reduce((total, product) => {
        //         // Assuming each product has a 'pricing' and 'quantity' property
        //         const productTotal = (parseFloat(product.pricing) || 0) * (parseInt(product.quantity) || 0) - (product.discount * parseInt(product.quantity) || 0);
        //         return total + productTotal;
        //     }, 0).toFixed(2); // Format to 2 decimal places
        // },

        calculateSubTotalPrice() {
            return this.productList.reduce((total, product) => {
                // Assuming each product has a 'pricing' and 'quantity' property
                const productTotal = (parseFloat(product.pricing) || 0) * (parseInt(product.quantity) || 0) - (product.discount * parseInt(product.quantity) || 0);
                return (total + productTotal);
            }, 0).toFixed(2); // Format to 2 decimal places
        },

        calculateTotalPrice() {
            return this.productList.reduce((total, product) => {
                // Assuming each product has a 'pricing' and 'quantity' property
                const productTotal = ((parseFloat(product.pricing) || 0) * (parseInt(product.quantity) || 0) - (product.discount * parseInt(product.quantity) || 0)) * 1.1;
                return (total + productTotal);
            }, 0).toFixed(2); // Format to 2 decimal places
        },

        calculateTotalGST() {
            return this.productList.reduce((total, product) => {
                // Assuming each product has a 'pricing' and 'quantity' property
                const productTotal = ((parseFloat(product.pricing) || 0) * (parseInt(product.quantity) || 0) - (product.discount * parseInt(product.quantity) || 0)) * 0.1;
                return (total + productTotal);
            }, 0).toFixed(2); // Format to 2 decimal places
        },
        canEditContract() {
            return this.$parent && this.$parent.canEditContract;
        },
    },

    watch: {
        setItems(Val) {
            if (!isEmpty(Val)) {
                this.tempAvailableProducts = JSON.parse(JSON.stringify(this.availableProducts))
                this.productList = []
                this.productListOptions = []
                this.pricingOptionCount = 1
                this.convertLeadProductsToSelectedProducts(Val.items)
                this.availableProducts = JSON.parse(JSON.stringify(this.tempAvailableProducts))
            }
        },
    },

    created() {
        this.init()
    },

    mounted() {
        this.$emit('onReady')
    },

    methods: {

        handlePricingChanges(hasChanges) {
            this.hasPricingTableChanges = hasChanges;
            this.$emit('pricing-table-changes', hasChanges);
        },

        updatePricingTable(html) {
            this.$parent.setSectionContentById("start_pricing_table_section", html);
        },

        saveContract(contract_items) {
            this.$parent.saveContent(contract_items);
        },

        rebuildSchedule(contract_items) {
            this.$emit('rebuild-schedule', contract_items);
        },

        calculateOptionSubtotalPrice(productList) {
            return productList.reduce((total, product) => {
                // Assuming each product has a 'pricing' and 'quantity' property
                const productTotal = ((parseFloat(product.pricing) || 0) * (parseInt(product.quantity) || 0) - (product.discount * parseInt(product.quantity) || 0));
                return total + productTotal;
            }, 0).toFixed(2); // Format to 2 decimal places
        },

        calculateOptionTotalPrice(productList) {
            return productList.reduce((total, product) => {
                // Assuming each product has a 'pricing' and 'quantity' property
                const productTotal = ((parseFloat(product.pricing) || 0) * (parseInt(product.quantity) || 0) - (product.discount * parseInt(product.quantity) || 0)) * 1.1;
                return total + productTotal;
            }, 0).toFixed(2); // Format to 2 decimal places
        },

        calculateOptionGST(productList) {
            return productList.reduce((total, product) => {
                // Assuming each product has a 'pricing' and 'quantity' property
                const productTotal = ((parseFloat(product.pricing) || 0) * (parseInt(product.quantity) || 0) - (product.discount * parseInt(product.quantity) || 0)) * 0.1;
                return total + productTotal;
            }, 0).toFixed(2); // Format to 2 decimal places
        },

        toOptionName(count) {
            // Handle the special case: if count is 1, return an empty string
            if (count <= 1) {
                return '';
            }

            let result = '';
            let num = count; // Start with the actual count for conversion

            while (num > 0) {
                // Calculate the remainder when dividing by 26
                // This gives us the position of the current letter (1 for A, 26 for Z)
                let remainder = num % 26;

                // Adjustment for 'Z' and subsequent columns:
                // If remainder is 0, it means the letter is 'Z' (the 26th letter)
                // and we need to decrement num by 26 to properly carry over for the next iteration.
                if (remainder === 0) {
                    remainder = 26; // Map 0 remainder to the 26th letter ('Z')
                }

                // Convert the remainder to a character
                // 'A' has ASCII value 65. So, (remainder - 1) + 65 gives us the correct character code
                // (e.g., if remainder is 1, 1-1=0, 65+0=65='A')
                result = String.fromCharCode(64 + remainder) + result;

                // Update num for the next iteration
                // If remainder was 26 (meaning 'Z'), we effectively processed a full '26' group.
                // So, subtract 'remainder' and then divide by 26.
                num = Math.floor((num - remainder) / 26);
            }

            return result;
        },

        init() {
            this.getAllVariableFieldBlocks()
            this.getOrganisationVariableFields()
            //this.getProductVariableFields()
            //this.getUserVariableFields()
            this.getAuthOrganisations()
            this.getProductList()
        },

        handleClick(clickLabel) {
            if (clickLabel == "Cover Page") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "CoverPage" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_cover_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "Testimonials") {
                this.variableButtons = []
                this.showTestimonial = true
                this.showPricingTableSettings = false
                this.hasPricingTableActive = false
                this.$emit("pricingTableInActive")
                return
            } else if (clickLabel == "Pricing Table") {
                this.$refs.pricingTableModal.openModal();
                return
            } else if (clickLabel == "Product / Service") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "ProductService" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_product_services_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "Conflict of Interest") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "Content" && vfield.content_type != undefined && vfield.content_type.name == "ConflictsOfInterest" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_content_conflict_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "Insurance") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "Content" && vfield.content_type != undefined && vfield.content_type.name == "Insurances" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_content_insurance_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "WHS Responsibilities") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "Content" && vfield.content_type != undefined && vfield.content_type.name == "WHSResponsibilities" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_content_whsr_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "Terms & Condition") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "Content" && vfield.content_type != undefined && vfield.content_type.name == "TermsAndConditions" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_content_terms_condition_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "Image Grid") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "Image" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_image_grid_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "Master Terms") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "MasterTerms" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_master_terms_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "Standard") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "ServiceModuleStandard" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_standard_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "Term") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "ServiceModuleTerm" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_term_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "Subscription") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "ServiceModuleSubscription" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_subscription_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "Schedule") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "ScheduleTable" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_schedule_table_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            } else if (clickLabel == "Execution Page") {
                this.variableButtons = []
                if (this.allBlocks.length > 0)
                    this.allBlocks.forEach((vfield) => {
                        if (vfield.BlockType != undefined && vfield.BlockType != null && vfield.BlockType.name == "ExecutionPage" && !isEmpty(vfield.content))
                            this.variableButtons.push(
                                {
                                    section_id: "start_execution_page_section",
                                    label: vfield.block_name,
                                    is_default: vfield.default_version,
                                    field_value: vfield.content
                                }
                            )
                    })
            }

            this.$emit("pricingTableInActive")
            this.hasPricingTableActive = false
            this.showTestimonial = false
            this.showPricingTableSettings = false
        },

        handleVariableClick(section_id, variable_value) {
            // All contract variable replacement is handled by the backend
            // during BuildContractSectionContent — pass raw content through.
            this.$parent.appendToSectionContentById(section_id, variable_value);
        },

        async handleReplace(section_id, variable_value) {
            this.$parent.setSectionContentById(section_id, variable_value);
            // Auto-save and resolve variable fields on the backend
            await this.$parent.saveContent([]);
            await this.$parent.resolveVariableFields();
        },

        GetOrganisationName(org_id) {
            const organisation = this.organisations.find(org => org.id === org_id);
            return organisation ? organisation.name : null; // Or handle the case where no match is found
        },

        addTestimonialToContent(testimonial, b64img) {
            let hasb64Image = b64img != null && b64img != undefined
            let b64NoImage = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACoCAMAAABt9SM9AAAAOVBMVEXU1NSampqXl5fX19fMzMyVlZXQ0NCgoKC/v7/ExMSkpKS6urqpqanT09OdnZ3Jycm0tLS1tbWtra0K+9GZAAAC+0lEQVR4nO3ci46iMBSAYeih3OSivv/DLqCFIiACGcl6/i+7yUQHM/wRaIszQQAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8CAniA+TsH/+r5FKZMNz3r/mf1IpyydWGh5j67F34nuhgqzBM9Ly1LuZoLBOfvQ9f08Yqyr2n96iNFZ29D1/Txdp9IMVGUywh1udGsWSzoDsMH1/+Pj/WLd+uPcN3X9yj3881xIqTQ9dFY7Oz9+XP9bGkODyGKM/emb/Wxyq7t8du7cbp2Tvz1/pYUbu/6W7Nyctcfv2sNYplyp27K+1BrC3W7okLsd5vOCojhb7D8NNYUqa3i7+QRazlje62uQBab92PWIvy55DMpi4PsZY2uffDV+vGocRaEA9DfXN1U3BizW+RevOixD1IrPktbv4k0j1IrOUtnOp50iJWa2YlIfNiFZyzvKeLbFqg6lvZjFiD2s4EzNytRlMwzvKeTUJTTbfJbHck2oIR/MuTZnrvR+Jrcyjm3hFKrCDo3kDmNo3Qrjn4jxLLzWuGKeDyy6iPFbkxwvptVPWxJB/Gnu8ytM+pj+XNAU3+5hXSmlji3xLslxemL3CzkfZY5Xi+HJqlk/zdGPWx/FWrR63ZSXaZm5BY07v51XROLXH1vFbqjlVPPvkwHcnL45vUx5LqtdX0JC+pDYn1ssDXG4/km8tgSKzg+ZGamfeWP5K/++N7xbG8m12LJ/nho2/KY03P7q5L/ujRXAa94b3qWN6kcOYkL4FI/Xpwqo3lrnILtS6N0TeojhXMDBu8NM8PRRKrjSXXjZ/E1Rwr2thKc6ztH/HWHOvtGYtY41gJsZa4WEKsdY9YcRzXxFrXrS/YRkisVf7yMbFW9MtSxPqApEl7FBoXqzsmN1EUK+jWEWSY7mz/3V9FsR6O/qITsT6mMdaOY/Dpri5WmOwWqoolKwOEdVbRnzt6t5j80XBr/98d+f80s8QDrCnO3oGvkjI7QMEfDAEAAAAAAAAAAAAAAAAAAAAAAAAAAIAa/wDYuS0/E15ttAAAAABJRU5ErkJggg==`

            if (this.$parent.checkIfIDExist(`testimonial_hash_${testimonial.id}`)) {
                alert("Testimonial already exist")
                return
            }

            this.$parent.addTestimonialToGrid(testimonial, `
            <div class="testimonial-container" id="testimonial_hash_${testimonial.id}">
                 <button class="remove-testimonial-button">X</button>
                <div class="testimonial-avatar">
                    <img src="${(hasb64Image) ? b64img : b64NoImage}" alt="Testimonial Image">
                </div>
                <div class="testimonial-content">
                    <p class="testimonial-text">"${testimonial.testimonial}"</p>
                    <p class="testimonial-author">${testimonial.contact_name}</p>
                    <p class="testimonial-title">${testimonial.contact_role + "-" +
                this.GetOrganisationName(testimonial.organisation_id)}</p>
                </div>
            </div>`)
        },

        //added block type async function
        async getAllVariableFieldBlocks() {
            await this.$axios.get("/blocks/all?blockUse=Contract")
                .then((response) => {
                    this.allBlocks = response.data.blocks
                    log(this.allBlocks)
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        //added block type async function
        async getProductVariableFields() {
            await this.$axios.get("/categories?name=ProductVariableFields")
                .then((response) => {
                    this.productVariableFields = response.data.category.subcategories
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        //added block use async function
        async getRolesVariableFields() {
            await this.$axios.get("/categories?name=RolesVariableFields")
                .then((response) => {
                    this.rolesVariableFields = response.data.category.subcategories
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        //added block use async function
        async getOrganisationVariableFields() {
            await this.$axios.get("/categories?name=OrganisationVariableFields")
                .then((response) => {
                    this.organisationVariableFields = response.data.category.subcategories
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        //added block use async function
        async getUserVariableFields() {
            await this.$axios.get("/categories?name=UserVariableFields")
                .then((response) => {
                    this.userVariableFields = response.data.category.subcategories
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        async getAuthOrganisations() {
            await this.$axios_auth.get("/vertex/organisations")
                .then((response) => {
                    this.organisations = response.data.organisations
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        //pricing table functions
        async getProductList() {
            await this.$axios.get("/get-product-pricing")
                .then((response) => {
                    this.availableProducts = []
                    response.data.productPrices.forEach((p) => {
                        this.availableProducts.push({
                            id: p.ProductID,
                            name: p.DisplayName,
                            defaultPricing: p.Price,
                            description: p.Description,
                            defaultQuantity: 1,
                            isCharityProduct: p.IsCharityProduct,
                        })
                    })
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        formatCurrency(value) {
            const numericValue = parseFloat(value);
            if (isNaN(numericValue)) {
                return '$0.00';
            }
            return `$${numericValue.toFixed(2)}`;
        },
        calculateTotal(item) {
            return (item.quantity * item.pricing) - (item.discount * item.quantity);
        },
        calculateTotalDiscount(item) {
            return (item.discount * item.quantity);
        },
        addProduct(index) {
            this.isSelectingProduct = !this.isSelectingProduct;
            this.newProductIndex = index;
            this.hasPricingTableChanges = true;
        },

        addProductOption(productOption, index) {
            productOption.isSelectingProduct = !productOption.isSelectingProduct;
            productOption.newProductIndex = index;
            this.hasPricingTableChanges = true;
        },

        startEdit(index, field) {
            // Ensure only one field is being edited at a time for a row
            this.productList.forEach((item, i) => {
                if (i === index) {
                    item[`isEditing${field.charAt(0).toUpperCase() + field.slice(1)}`] = true;
                    item['current_product'] = item.product
                    item['current_qty'] = item.quantity
                    item['current_price'] = item.pricing
                    item['current_discount'] = item.discount
                    item['current_remarks'] = item.remarks
                    item['current_description'] = item.description
                } else {
                    item.isEditingProduct = false;
                    item.isEditingQuantity = false;
                    item.isEditingPricing = false;
                    item.isEditingDiscount = false;
                    item.isEditingRemarks = false;
                    item.isEditingDescription = false;
                }
            });
        },

        //startEdit for options
        startEditOption(productList, index, field) {
            // Ensure only one field is being edited at a time for a row
            productList.forEach((item, i) => {
                if (i === index) {
                    item[`isEditing${field.charAt(0).toUpperCase() + field.slice(1)}`] = true;
                    item['current_product'] = item.product
                    item['current_qty'] = item.quantity
                    item['current_price'] = item.pricing
                    item['current_discount'] = item.discount
                    item['current_remarks'] = item.remarks
                    item['current_description'] = item.description
                } else {
                    item.isEditingProduct = false;
                    item.isEditingQuantity = false;
                    item.isEditingPricing = false;
                    item.isEditingDiscount = false;
                    item.isEditingRemarks = false;
                    item.isEditingDescription = false;
                }
            });

        },

        endEdit(item, field) {
            item[`isEditing${field.charAt(0).toUpperCase() + field.slice(1)}`] = false;
            if (item["current_product"] != item["product"] || item["current_qty"] != item["quantity"] || item["current_price"] != item["pricing"] || item["current_discount"] != item["discount"] || item["current_remarks"] != item["remarks"] || item["current_description"] != item["description"]) {
                this.hasPricingTableChanges = true
            }
        },

        endEditOption(item, field) {
            item[`isEditing${field.charAt(0).toUpperCase() + field.slice(1)}`] = false;
            if (item["current_product"] != item["product"] || item["current_qty"] != item["quantity"] || item["current_price"] != item["pricing"] || item["current_discount"] != item["discount"] || item["current_remarks"] != item["remarks"] || item["current_description"] != item["description"]) {
                this.hasPricingTableChanges = true
            }
        },

        selectProduct(selectedProduct) {


            log("product:", selectedProduct)

            const existingProductIndex = this.productList.findIndex(
                (item) => item.id === selectedProduct.id
            );

            if (existingProductIndex > -1) {
                // Product already exists, increment quantity
                // this.productList[existingProductIndex].quantity++;
                this.productList.splice(existingProductIndex + 1, 0, {
                    id: selectedProduct.id,
                    product: selectedProduct.name,
                    description: selectedProduct.description || "No Product Description",
                    remarks: (selectedProduct.remarks) ? selectedProduct.remarks : "",
                    quantity: selectedProduct.defaultQuantity || 1,
                    discount: (selectedProduct.isCharityProduct && this.isCharityLead) ? selectedProduct.defaultPricing : (selectedProduct.defaultDiscount || 0.00),
                    pricing: selectedProduct.defaultPricing || 0.00,
                    isEditingProduct: false,
                    isEditingDescription: false,
                    isEditingRemarks: false,
                    isEditingQuantity: false,
                    isEditingPricing: false,
                    isEditingDiscount: false
                });
            } else {
                // Product doesn't exist, add it to the list
                this.productList.push({
                    id: selectedProduct.id,
                    product: selectedProduct.name,
                    description: selectedProduct.description || "No Product Description",
                    remarks: (selectedProduct.remarks) ? selectedProduct.remarks : "",
                    quantity: selectedProduct.defaultQuantity || 1,
                    discount: (selectedProduct.isCharityProduct && this.isCharityLead) ? selectedProduct.defaultPricing : (selectedProduct.defaultDiscount || 0.00),
                    pricing: selectedProduct.defaultPricing || 0.00,
                    isEditingProduct: false,
                    isEditingDescription: false,
                    isEditingRemarks: false,
                    isEditingQuantity: false,
                    isEditingPricing: false,
                    isEditingDiscount: false
                });
            }

            this.isSelectingProduct = false;
            this.newProductIndex = -1;
            this.hasPricingTableChanges = true;
        },

        selectProductOption(productOption, selectedProduct) {
            const existingProductIndex = productOption.productList.findIndex(
                (item) => item.id === selectedProduct.id
            );

            if (existingProductIndex > -1) {
                // Product already exists, increment quantity
                //productOption.productList[existingProductIndex].quantity++;

                productOption.productList.splice(existingProductIndex + 1, 0, {
                    id: selectedProduct.id,
                    product: selectedProduct.name,
                    description: selectedProduct.description || "No Product Description",
                    remarks: (selectedProduct.remarks) ? selectedProduct.remarks : "",
                    quantity: selectedProduct.defaultQuantity || 1,
                    discount: (selectedProduct.isCharityProduct && this.isCharityLead) ? (selectedProduct.defaultDiscount > 0) ? selectedProduct.defaultDiscount : selectedProduct.defaultPricing : (selectedProduct.defaultDiscount || 0.00),
                    pricing: selectedProduct.defaultPricing || 0.00,
                    isEditingProduct: false,
                    isEditingDescription: false,
                    isEditingRemarks: false,
                    isEditingQuantity: false,
                    isEditingPricing: false,
                    isEditingDiscount: false
                });
            } else {
                // Product doesn't exist, add it to the list
                productOption.productList.push({
                    id: selectedProduct.id,
                    product: selectedProduct.name,
                    description: selectedProduct.description || "No Product Description",
                    remarks: (selectedProduct.remarks) ? selectedProduct.remarks : "",
                    quantity: selectedProduct.defaultQuantity || 1,
                    discount: (selectedProduct.isCharityProduct && this.isCharityLead) ? (selectedProduct.defaultDiscount > 0) ? selectedProduct.defaultDiscount : selectedProduct.defaultPricing : (selectedProduct.defaultDiscount || 0.00),
                    pricing: selectedProduct.defaultPricing || 0.00,
                    isEditingProduct: false,
                    isEditingDescription: false,
                    isEditingRemarks: false,
                    isEditingQuantity: false,
                    isEditingPricing: false,
                    isEditingDiscount: false
                });
            }

            productOption.isSelectingProduct = false;
            productOption.newProductIndex = -1;
            this.hasPricingTableChanges = true;
        },


        removeProductOption(productOption, productList, indexToRemove) {

            if (productList.length == 1) {
                this.removeOption(productOption)
                return
            }
            // // Find the index of the product to remove
            // const indexToRemove = productList.findIndex(
            //     (item) => item.id === productIdToRemove
            // );

            if (indexToRemove > -1) {
                // Remove the product from the productList array
                productList.splice(indexToRemove, 1);
            }

            this.hasPricingTableChanges = true;
        },

        removeProduct(indexToRemove) {
            // Find the index of the product to remove

            if (this.productList.length == 1) {
                alert("Cannot remove last product on table. Please add another one for replacement.")
                return
            }

            // const indexToRemove = this.productList.findIndex(
            //     (item) => item.id === productIdToRemove
            // );

            if (indexToRemove > -1) {
                // Remove the product from the productList array
                this.productList.splice(indexToRemove, 1);
            }

            this.hasPricingTableChanges = true;
        },

        convertLeadProductsToSelectedProducts(products_array) {
            if (!isEmpty(products_array) && products_array.length > 0) {
                products_array.forEach((p) => {

                    if (p.option_index == 1) {
                        let productFromList = this.availableProducts.find(
                            (item) => item.id === p.product_id
                        );

                        if (productFromList == undefined || productFromList == null) {
                            return
                        }

                        this.isCharityLead = p.is_charity
                        const prodToSelect = {
                            ...productFromList,
                            name: p.product_name || p.product || productFromList.name,
                            defaultQuantity: p.quantity,
                            defaultPricing: p.price,
                            defaultDiscount: p.discount,
                            remarks: p.remarks
                        };
                        this.selectProduct(prodToSelect)
                    } else if (p.option_index >= 2) {
                        //other options
                        if (isEmpty(this.productListOptions[p.option_index - 2])) {
                            this.productListOptions.push({
                                productList: [],
                                isSelectingProduct: false,
                                newProductIndex: -1
                            })

                            this.pricingOptionCount++
                        }
                        let productFromList = this.availableProducts.find(
                            (item) => item.id === p.product_id
                        );

                        if (productFromList == undefined || productFromList == null) {
                            return
                        }

                        this.isCharityLead = p.is_charity
                        const prodToSelect = {
                            ...productFromList,
                            name: p.product_name || p.product || productFromList.name,
                            defaultQuantity: p.quantity,
                            defaultPricing: p.price,
                            defaultDiscount: p.discount,
                            remarks: p.remarks
                        };
                        this.selectProductOption(this.productListOptions[p.option_index - 2], prodToSelect)
                    }

                    this.hasPricingTableChanges = false;
                })
            }
        },

        addPricingOption() {

            let pO = [];

            if (!isEmpty(this.productList)) {
                this.productList.forEach(p => {
                    pO.push(JSON.parse(JSON.stringify(p)))
                })
            }

            this.productListOptions.push({
                productList: pO,
                isSelectingProduct: false,
                newProductIndex: -1
            })
            this.pricingOptionCount += 1
            this.hasPricingTableChanges = true;
        },

        removeOption(productOption) {
            let index = this.productListOptions.indexOf(productOption)
            this.productListOptions.splice(index, 1)
            this.hasPricingTableChanges = true;
        },

        buildPricingTable() {

    //         let productsToPropagate = ""
    //         let optionsToPropagate = ""

    //         this.productList.forEach(p => {
    //             productsToPropagate +=
    //                 `<tr id='product_list_${p.id}'>
    //                    <td style="border-color: black; border-width: 1px; text-align: center;">${p.product}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${p.description || "No Product Description"}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${p.remarks || "No Remarks"}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${p.quantity}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(p.pricing)}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(p.discount)}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(this.calculateTotalDiscount(p))}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(this.calculateTotal(p))}</td>
    //                 </tr>
    //             `})

    //         productsToPropagate += `
    //                 <tr>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;"><b>Subtotal<b></td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(this.calculateSubTotalPrice)}</td>
    //   </tr>
    //   <tr>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td title="Goods and Services Tax" style="border-color: black; border-width: 1px; text-align: center;"><b>GST (10%)<b></td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(this.calculateTotalGST)}</td>
    //   </tr>
    //   <tr>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //        <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;"><b>Total AUD<b></td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(this.calculateTotalPrice)}</td>
    //   </tr>
    //             `
    //         if (!isEmpty(this.productListOptions))
    //             this.productListOptions.forEach((plo, index) => {
    //                 let optionBody = ""

    //                 if (!isEmpty(plo.productList)) {
    //                     plo.productList.forEach(p => {
    //                         optionBody +=
    //                             `<tr id='product_list_${p.id}'>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">${p.product}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${p.description || "No Product Description"}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${p.remarks || "No Remarks"}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${p.quantity}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(p.pricing)}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(p.discount)}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(this.calculateTotalDiscount(p))}</td>
    //       <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(this.calculateTotal(p))}</td>
    //                 </tr>
    //             `})

    //                     optionBody += `
    //                  <tr>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;"><b>Subtotal<b></td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(this.calculateOptionSubtotalPrice(plo.productList))}</td>
    //                 </tr>
    //                 <tr>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td title="Goods and Services Tax" style="border-color: black; border-width: 1px; text-align: center;"><b>GST (10%)<b></td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(this.calculateOptionGST(plo.productList))}</td>
    //                 </tr>
    //                 <tr>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">-</td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;"><b>Total AUD<b></td>
    //                     <td style="border-color: black; border-width: 1px; text-align: center;">${this.formatCurrency(this.calculateOptionTotalPrice(plo.productList))}</td>
    //                 </tr>
    //             `

    //                     optionsToPropagate += `
                
    //             <br>
    //             <span class="orange-label-product-option" style="margin-left: 0;">Pricing for Option ${this.toOptionName(index + 2)}</span>
    //             <table style="border-collapse: collapse; width: 100%; border-color: black; border: 2px solid black;" border="1">
    //             <thead>
    //                 <tr>
    //                     <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Product</th>
    //                     <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Description</th>
    //                     <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Notes</th>
    //                     <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Quantity</th>
    //                     <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Price</th>
    //                     <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Per Item Discount</th>
    //                     <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Total Discount</th>
    //                     <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Total AUD</th>
    //                 </tr>
    //             <thead>
    //             <tbody>
    //                 ${optionBody}
    //             </tbody>
    //             </table>
    //             `
    //                 }
    //             })

    //         this.$parent.setSectionContentById("start_pricing_table_section", `<table style="border-collapse: collapse; width: 100%; border-color: black; border: 2px solid black;" border="1">
    //             <thead>
    //                 <tr>
    //                      <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Product</th>
    //                      <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Description</th>
    //                      <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Notes</th>
    //                      <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Quantity</th>
    //                      <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Price</th>
    //                      <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Per Item Discount</th>
    //                      <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Total Discount</th>
    //                      <th style="background-color: #00a0c1; border-color: black; color: white; border-width: 1px; text-align: center;">Total AUD</th>
    //                 </tr>
    //             <thead>
    //             <tbody>
    //                 ${productsToPropagate}
    //             </tbody>
    //             </table>
    //                 ${(!isEmpty(optionsToPropagate) ? optionsToPropagate : "")}
    //         `)

            this.hasPricingTableChanges = false;

            let contract_items = []
            this.productList.forEach((p) => {
                contract_items.push({
                    product_id: p.id.toString(),
                    product_name: p.product,
                    description: p.description,
                    price: p.pricing,
                    quantity: p.quantity,
                    discount: p.discount,
                    option_index: 1,
                    remarks: p.remarks
                })
            })

            if (!isEmpty(this.productListOptions))
                this.productListOptions.forEach((plo, index) => {
                    if (!isEmpty(plo.productList)) {
                        plo.productList.forEach((p) => {
                            contract_items.push({
                                product_id: p.id.toString(),
                                product_name: p.product,
                                description: p.description,
                                price: p.pricing,
                                quantity: p.quantity,
                                discount: p.discount,
                                option_index: index + 2,
                                remarks: p.remarks
                            })
                        })
                    }
                })

            log(contract_items)
            this.$parent.saveContent(contract_items)
            // this.filterContractItems(contract_items)
        },
    },
};

</script>

<style scoped>
/* form start */
form label:not(#isCharityLbl) {
    color: #00A0C1;
    margin: 0.5rem 0;
}

input:not([type="checkbox"]),
select {
    height: 40px;
    border-radius: 10px;
    max-width: 100px;
    border: 1px solid #D9D9D9;
    color: #435666;
}

.form--check-input {
    width: 12px;
    /* Increase width */
    height: 12px;
    /* Increase height */
    margin-left: -17px;
    margin-right: 10px;
}

/* form end */
.btn {
    width: 7rem;
}

.add-space {
    margin-bottom: 225px;
}

.button-group {
    display: grid;
    /* Use grid for layout */
    grid-template-columns: repeat(4, 1fr);
    /* 4 equal-width columns */
    grid-gap: 10px;
    /* Spacing between grid items */
}

.button-group-variable {
    display: grid;
    /* Use grid for easy layout */
    grid-template-columns: repeat(1, 1fr);
    /* 4 columns */
    grid-gap: 5px;
    /* Spacing between buttons */
    padding: 10px;
    overflow-y: auto;
    scrollbar-color: #00A0C1 lightblue;
    max-height: clamp(300px, calc(100vh - 300px), 900px);
    overflow-x: hidden;
}

.block-button-container {
    display: flex;
    margin-left: -3px;
    gap: 3px;
}

@media (min-width: 1900px) {

    /* Adjust breakpoint as needed */
    .block-button-container {
        gap: 6px;
        /* Larger gap for larger screens */
    }
}



/* pricing table */

.product-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    border: 1px solid #ddd;
}

.product-table th,
.product-table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.product-table th {
    background-color: #00bcd4;
    color: white;
    font-weight: bold;
}

.product-table tr:last-child td {
    border-bottom: none;
}

.product-table td:first-child {
    align-items: center;
}

.product-table td:first-child>span {
    margin-right: 5px;
}

.add-product-row td {
    color: #00bcd4;
    cursor: pointer;
}

.remove-button {
    background-color: #ff9800;
    color: whitesmoke;
    border: 1px solid #ff9800;
}

.add-product-row td:first-child {
    font-weight: bold;
}

.add-product-row td:last-child {
    font-weight: bold;
    color: #ff8c00
}

.product-selection-list {
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    padding: 10px;
    margin-top: 5px;
    border-radius: 5px;
}

.product-item {
    padding: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.product-item:hover {
    background-color: #eee;
}

.product-table td input[type="number"] {
    width: 70px;
    /* Adjust this value to control the width */
    padding: 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.9em;
    text-align: left;
    /* Align the number to the right */
}

.product-table td input[type="number"]:focus {
    outline: none;
    border-color: #00bcd4;
    box-shadow: 0 0 5px rgba(0, 188, 212, 0.5);
}

.product-selection-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 16px;
}

.product-selection-table th,
.product-selection-table td {
    padding: 8px;
    border: 1px solid #ddd;
    text-align: left;
}

.product-selection-table th {
    background-color: #f2f2f2;
    font-weight: bold;
    /* Optional: Keep header fixed during scroll */
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #f2f2f2;
}

.product-item {
    /* Remove default styling for the div */
    padding: 0;
    margin: 0;
    border: none;
    cursor: pointer;
    /* Optional: indicate it's interactive */
}

.product-item strong {
    /* Style the product name */
}

.total-row {
    font-weight: bold;
    background-color: #f9f9f9;
}

.total-label {
    text-align: right;
    padding-right: 8px;
}

.total-amount {
    text-align: right;
}

.continue {
    background-color: #00bcd4;
    color: white;
}

.continue:disabled {
    background-color: lightgray;
    color: white;
}

.actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.button-select {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
}

.orange-label-product-option {
    display: inline-block;
    /* Allows padding and margin to work like a block */
    background-color: #ff8c00;
    /* A vibrant orange */
    color: white;
    /* White text for contrast */
    padding: 6px 12px;
    /* Good spacing around the text */
    border-radius: 5px;
    /* Slightly rounded corners */
    font-weight: bold;
    /* Bold text */
    font-size: 0.95em;
    /* Slightly smaller than default text */
    text-transform: uppercase;
    /* All caps for a label look */
    letter-spacing: 0.5px;
    /* A little space between letters */
}

.char-counter {
  display: block;
  text-align: right;
  font-size: 0.75rem;
  color: #6c757d;
  margin-top: 2px;
}

.product-name-cell {
    cursor: pointer;
}

.product-name-input {
    width: 100%;
    min-width: 120px;
    padding: 4px 8px;
    border: 1px solid #00bcd4;
    border-radius: 4px;
    font-size: 0.9em;
    font-weight: bold;
    outline: none;
    box-shadow: 0 0 5px rgba(0, 188, 212, 0.4);
}
</style>
